import { FormControlLabel, Switch } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import Authorize from "components/Authorize";
import NotificationProvider from "components/NotificationProvider";
import { useGetClientsWithConfigsQuery, useUpdateClientMutation } from "features/clients/clientConfigSlice";
import { clientConfigTypes, clientConfigTypeToName } from "features/clients/clientConfigsSetup";
import { useEffect, useState } from "react";
import { editParamStyle } from "./style";
import ConfirmationPopup from "components/ConfirmationPopup";
import { useSelector } from "react-redux";
import { formTypes } from "../../formBuilderConsts";

const EditBooleanCustomFormParameter = ({ configType, parameterName, label, name, clientId, profile }) => {

    const classes = editParamStyle();
    const { formType, activityItemId } = useSelector(state => state.formState);

    let { data: clientsWithConfigs, error: clientsWithConfigsError, isLoading: isLoadingClientsWithConfigs, isFetching: isFetchingClientsWithConfigs } = useGetClientsWithConfigsQuery(clientId);
    let [updateClient, { isLoading }] = useUpdateClientMutation();
    const configName = clientConfigTypeToName[configType];

    const [config, setConfig] = useState();
    const [paramIntValue, setParamIntValue] = useState();
    const [paramNewIntValue, setNewParamIntValue] = useState();
    const [confirmationOpen, setConfirmationOpen] = useState(false)


    useEffect(() => {
        const configuration = clientsWithConfigs?.[0]?.config?.[configName];
        setConfig(configuration);
        if (formType === formTypes.Activity && configType === clientConfigTypes.Mechanicals) {
            const useCustomActivityConfig = configuration?.[parameterName] ?? [];
            const useCustomActivity = useCustomActivityConfig.find(m => m.activityItemId === activityItemId);
            setParamIntValue(useCustomActivity?.on ? 1 : 0);
        } else
            setParamIntValue(configuration?.[parameterName] ? 1 : 0)
    }, [clientsWithConfigs, configName, activityItemId]);

    const onChangeParameter = async () => {
        onClose();
        setParamIntValue(paramNewIntValue);
        let value;
        if (formType === formTypes.Activity && configType === clientConfigTypes.Mechanicals) {
            value = config?.[parameterName] ?? [];
            value = [...value];
            let idx = value.findIndex(a => a.activityItemId === activityItemId);
            if (idx !== -1) {
                value[idx] = { ...value[idx], on: paramNewIntValue };
            } else {
                value.push({ activityItemId, on: paramNewIntValue });
            }
        } else {
            value = !!paramNewIntValue;
        }

        const configToSave = {
            ...clientsWithConfigs?.[0]?.config,
            [configName]: {
                ...config,
                [parameterName]: value,
                ...((configType === clientConfigTypes.Checkin && !!paramNewIntValue) ? { ['usePave']: false } : {})
            }
        };
        let result = await updateClient({ id: clientId, config: configToSave, configToUpdate: configType });
        if (result?.error) {
            NotificationProvider.error('Failed to update');
        } else {
            NotificationProvider.success('Successfully updated');
        }
    }

    const onClose = () => {
        setConfirmationOpen(false);
    }


    const onOpen = async (newValue) => {
        if (paramIntValue === newValue) return;

        setConfirmationOpen(true);
        setNewParamIntValue(newValue);
    }

    return (
        <>{!isLoadingClientsWithConfigs &&
            <FormControlLabel
                control={
                    <Authorize profile={profile}>
                        <ToggleButtonGroup
                            color="primary"
                            disabled={isLoading}
                            value={paramIntValue}
                            exclusive
                            aria-label="Platform"
                        >
                            <ToggleButton
                                disabled={isLoading}
                                selected={paramIntValue}
                                onClick={() => onOpen(1)}
                                className={paramIntValue ? classes.onSelected : classes.on}
                            >
                                <span>On</span>
                            </ToggleButton>
                            <ToggleButton
                                disabled={isLoading}
                                selected={!paramIntValue}
                                onClick={() => onOpen(0)}
                                className={paramIntValue ? classes.off : classes.offSelected}
                            >
                                <span>Off</span>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Authorize>
                }
            />}
            <ConfirmationPopup
                onCancel={() => {
                    onClose()
                }}
                onConfirm={() => {
                    onChangeParameter()
                }}
                open={confirmationOpen}
            >
                {paramNewIntValue === 1 ?
                    <> You are about to enable the <b>custom {name.toLowerCase()}</b>. When a form is on, the mobile app will use the custom form and not the standard SLA, are you sure you want to proceed? </>
                    : <> You are about to turn off the <b>custom {name.toLowerCase()}</b>. When a form is off, the mobile app will use the standard SLA, are you sure you want to proceed? </>
                }
                <br />
            </ConfirmationPopup>
        </>);
}

export default EditBooleanCustomFormParameter;
